import { api } from './client';

export interface Job {
  id: string;
  job_type: string;
  case_numbers: string[] | null;
  status: 'queued' | 'running' | 'completed' | 'failed';
  progress: number;
  total: number | null;
  result: Record<string, unknown> | null;
  error: string | null;
  enqueued_at: string;
  started_at: string | null;
  completed_at: string | null;
}

interface ActiveJobsResponse {
  jobs: Job[];
  total_active: number;
}

export const jobsApi = {
  /**
   * Get all active (queued or running) jobs
   */
  getActive: (): Promise<ActiveJobsResponse> => {
    return api.get<ActiveJobsResponse>('/jobs');
  },

  /**
   * Get recent jobs regardless of status
   */
  getRecent: (limit = 50): Promise<Job[]> => {
    return api.get<Job[]>(`/jobs/recent?limit=${limit}`);
  },

  /**
   * Get a specific job by ID
   */
  get: (jobId: string): Promise<Job> => {
    return api.get<Job>(`/jobs/${jobId}`);
  },

  /**
   * Get all jobs for a specific case number
   */
  getForCase: (caseNumber: string): Promise<Job[]> => {
    return api.get<Job[]>(`/jobs/case/${caseNumber}`);
  },
};
